<template>
  <div id="player_playing_time_distribution" class="border-padding">
  <main>
    <div class="row">
      <div class="col-md-4" v-if="season_dropdown.data != undefined">
        <season-select v-model="seasons_selected" :options="season_dropdown"></season-select>
      </div>

      <div class="col-md-2" v-if="season_type_dropdown.data != undefined">
        <season-type-select v-model="season_type_selected" :options="season_type_dropdown"></season-type-select>
      </div>

      <div class="col-md-1" v-if="team_dropdown.data != undefined">
        <team-select v-model="team_selected" :options="team_dropdown" :inputFunc="changePlayers" :preselectFirst="true" :allowEmpty="false"></team-select>
      </div>

      <div class="col-md-2" v-if="players.length > 0">
        <player-select v-model="player_selected" :options="players" label="Player"></player-select>
      </div>

    </div>

    <div class="border-padding">
      <button class="" v-on:click="changeStats()">Show Chart</button>
    </div>

    <div v-if="loading">
      Loading.....
    </div>
    <p style="color:red;" v-if="show_error_message">Error Getting Results</p>

    <div id="chart_container" class="row margin-padding">
      <svg width="800" height="600"></svg>
      <div id=legend></div>
    </div>

  </main>
  </div>
</template>

<script>
import axios from 'axios'
import GetDropdownOptions from './mixins/get_dropdown'
import Multiselect from 'vue-multiselect'
import SeasonTypeSelect from './mixins/SeasonTypeSelect.vue'
import SeasonSelect from './mixins/SeasonSelect.vue'
import TeamSelect from './mixins/TeamSelect.vue'
import PlayerSelect from './mixins/PlayerSelect.vue'
import { season, seasonType } from './mixins/dropdowns'
const d3 = require('d3')

export default {
  name: 'PlayerPlayingTime',
  components: {
    Multiselect,
    SeasonTypeSelect,
    SeasonSelect,
    TeamSelect,
    PlayerSelect
  },
  mixins: [SeasonTypeSelect, SeasonSelect, TeamSelect, PlayerSelect, GetDropdownOptions, season, seasonType],
  data () {
    return {
      loading: false,
      season_dropdown: {},
      seasons_selected: [],
      season_type_dropdown: {},
      season_type_selected: undefined,
      season_selected_string: '',
      players: [],
      player_selected: undefined,
      team_dropdown: {},
      team_selected: undefined,
      show_error_message: false,
      api_endpoint: 'get-playing-time-distribution/'
    }
  },
  created () {
    this.loadData()
  },
  watch: {
    '$route': 'updateData',
    '$parent.league': 'changeLeague'
  },
  methods: {
    changeLeague () {
      d3.selectAll('svg > *').remove()
      d3.select('div#legend').html('')
      this.table_data = []
      this.seasons_selected = []
      this.$router.push({name: 'player_playing_time_distribution', params: {league: this.$parent.league, type: this.$route.params.type}})
    },
    checkIfStatsShouldBeLoaded () {
      if (this.seasons_selected.length > 0 && this.season_type_selected && this.team_selected) {
        this.changePlayers()
        this.getStats()
      }
    },
    loadData () {
      this.getDropdown([this.setSeasonDropdown, this.setSeasonTypeDropdown, this.setTeamDropdown, this.checkIfStatsShouldBeLoaded])
    },
    updateData () {
      if (this.$route.query.Season && this.$route.query.SeasonType && this.$route.query.TeamId && this.$route.query.PlayerId) {
        this.getStats()
      } else {
        this.loadData()
      }
    },
    changePlayers () {
      this.getPlayersForTeam([this.setPlayerSelected])
    },
    changeStats () {
      var params = {}

      this.season_selected_string = this.getSeasonsSelectedString()
      params[this.$seasonParam] = this.season_selected_string
      params[this.$seasonTypeParam] = this.season_type_selected.id

      if (this.team_selected) {
        params[this.$teamIdParam] = this.team_selected.id
      }
      if (this.player_selected) {
        params[this.$playerIdParam] = this.player_selected.playerId
      }

      this.$router.push({name: 'player_playing_time_distribution', query: params})
    },
    getStats () {
      this.show_error_message = false
      d3.selectAll('svg > *').remove()
      d3.select('div#legend').html('')
      var params = this.$route.query

      if (params.Season && params.SeasonType && params.TeamId && params.PlayerId) {
        this.loading = true
        axios.get(process.env.API_BASE_URL + this.api_endpoint + this.$route.params.league, {
          params: params
        })
          .then((response) => {
            if (!response.data.error) {
              this.results = response.data.results
              this.max_y_axis_value = response.data.max_y_axis_value
              this.addChart(this.results, this.max_y_axis_value)
            } else {
              this.show_error_message = true
            }
            this.loading = false
          }, (error) => {
            this.show_error_message = true
            this.loading = false
            this.error = error
          })
      }
    },
    addChart (data, maxYAxisValue) {
      var svg = d3.select('svg')
      var margin = {top: 20, right: 20, bottom: 30, left: 50}
      var width = +svg.attr('width') - margin.left - margin.right
      var height = +svg.attr('height') - margin.top - margin.bottom
      var g = svg.append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')

      var tooltip = d3.select('div#chart_container').append('div').attr('class', 'playing-time-tooltip')

      var x = d3.scaleBand()
        .rangeRound([0, width])
        .paddingInner(0.05)
        .align(0.1)

      var y = d3.scaleLinear()
        .rangeRound([height, 0])

      var z = d3.scaleLinear()
        .range(['red', 'green'])

      for (var i = 0; i < data.length; i++) {
        data[i]['GameNumber'] = i + 1
        for (var j = 0; j < data[i].Possessions.length; j++) {
          data[i].Possessions[j]['Date'] = data[i].Date
          data[i].Possessions[j]['GameNumber'] = i + 1
          data[i].Possessions[j]['Opponent'] = data[i].Opponent
        }
      }

      x.domain(data.map(function (d) { return d.GameNumber }))
      y.domain([0, maxYAxisValue / 60])
      z.domain([-20, 20])

      g.append('g')
        .selectAll('g')
        .data(data)
        .enter().append('g')
        .selectAll('rect')
        .data(function (d) { return d.Possessions })
        .enter().append('rect')
        .attr('x', function (d) { return x(d.GameNumber) })
        .attr('y', function (d) { return y(d.EndTime / 60) })
        .attr('fill', function (d) { return z(d.ScoreMargin) })
        .attr('height', function (d) { return y(d.StartTime / 60) - y(d.EndTime / 60) })
        .attr('width', x.bandwidth())
        .on('mousemove', function (d) {
          tooltip
            .style('left', d3.event.pageX - 50 + 'px')
            .style('top', d3.event.pageY - 70 + 'px')
            .style('display', 'inline-block')
            .html((d.Date) + (d.Opponent))
        })
        .on('mouseout', function (d) { tooltip.style('display', 'none') })

      var tickLabels = ['End Q1', 'End Q2', 'End Q3', 'End Q4']
      var tickValues
      if (this.$parent.league === 'wnba') {
        tickValues = [10, 20, 30, 40]
      } else {
        tickValues = [12, 24, 36, 48]
      }

      g.append('g')
        .attr('class', 'axis')
        .call(d3.axisLeft(y).tickValues(tickValues).tickFormat(function (d, i) { return tickLabels[i] }))
        .append('text')
        .attr('x', 2)
        .attr('y', y(y.ticks().pop()) + 0.5)
        .attr('dy', '0.32em')
        .attr('fill', '#000')
        .attr('font-weight', 'bold')
        .attr('text-anchor', 'start')

      g.append('g')
        .selectAll('g')
        .data(tickValues)
        .enter().append('line')
        .attr('class', 'period-break')
        .attr('x1', 0)
        .attr('y1', function (d) { return y(d) })
        .attr('x2', x(data.length) + x.bandwidth())
        .attr('y2', function (d) { return y(d) })

      this.addLegend('div#legend', z)
    },
    addLegend (selectorId, colorscale) {
      d3.select(selectorId).html('')
      // from http://bl.ocks.org/syntagmatic/e8ccca52559796be775553b467593a9f
      var legendheight = 200
      var legendwidth = 80
      var margin = {top: 20, right: 60, bottom: 20, left: 2}

      var canvas = d3.select(selectorId)
        .style('height', legendheight + 'px')
        .style('width', legendwidth + 'px')
        .style('position', 'relative')
        .append('canvas')
        .attr('height', legendheight - margin.top - margin.bottom)
        .attr('width', 1)
        .style('height', (legendheight - margin.top - margin.bottom) + 'px')
        .style('width', (legendwidth - margin.left - margin.right) + 'px')
        .style('border', '1px solid #000')
        .style('position', 'absolute')
        .style('top', (margin.top) + 'px')
        .style('left', (margin.left) + 'px')
        .node()

      var ctx = canvas.getContext('2d')

      var legendscale = d3.scaleLinear()
        .range([1, legendheight - margin.top - margin.bottom])
        .domain(colorscale.domain())

      // image data hackery based on http://bl.ocks.org/mbostock/048d21cf747371b11884f75ad896e5a5
      var image = ctx.createImageData(1, legendheight)
      d3.range(legendheight).forEach(function (i) {
        var c = d3.rgb(colorscale(legendscale.invert(i)))
        image.data[4 * i] = c.r
        image.data[4 * i + 1] = c.g
        image.data[4 * i + 2] = c.b
        image.data[4 * i + 3] = 255
      })
      ctx.putImageData(image, 0, 0)

      var legendaxis = d3.axisRight()
        .scale(legendscale)
        .tickSize(6)
        .ticks(8)

      var svg = d3.select(selectorId)
        .append('svg')
        .attr('height', (legendheight) + 'px')
        .attr('width', (legendwidth) + 'px')
        .style('position', 'absolute')
        .style('left', '0px')
        .style('top', '0px')

      svg
        .append('g')
        .attr('class', 'axis')
        .attr('transform', 'translate(' + (legendwidth - margin.left - margin.right + 3) + ',' + (margin.top) + ')')
        .call(legendaxis)

      svg
        .append('text')
        .attr('transform', 'translate(' + (legendwidth - margin.left - margin.right - 15) + ',' + (legendheight - 5) + ')')
        .style('font-size', '10px')
        .text('Margin')
    }
  }
}
</script>

<style>
.playing-time-tooltip {
  position: absolute;
  display: none;
  height: auto;
  background: none repeat scroll 0 0 #ffffff;
  border: 1px solid black;
  text-anchor: middle;
  padding: 5px;
}

.margin-padding {
  border-width: 4px;
  padding: 10px;
}

svg .axis,
svg line.period-break {
  fill: none;
  stroke: black;
  stroke-width: .5;
}

</style>



// WEBPACK FOOTER //
// src/components/PlayerPlayingTime.vue